import { render, staticRenderFns } from "./portfolio-chart-header.component.vue?vue&type=template&id=6b8742eb"
import script from "./portfolio-chart-header.component.vue?vue&type=script&lang=js"
export * from "./portfolio-chart-header.component.vue?vue&type=script&lang=js"
import style0 from "./portfolio-chart-header.component.vue?vue&type=style&index=0&id=6b8742eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports